import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CreateProfile from '../steps/registration/CreateProfile';
import SuggestedFriends from '../steps/registration/SuggestedFriends';
import FacebookFriends from '../steps/registration/FacebookFriends';
import Welcome from '../steps/registration/Welcome';
import { stepToUrl } from '../../shared/onboarding-utils';
import { routesConfig } from '../../shared/onboarding-config';
import { REGISTRATION_FLOW } from '../../shared/onboarding-constants';
import { useOnboardingContext } from '../../state/OnboardingContext';

const RegistrationFlowRoutes = () => {
  const { state } = useOnboardingContext();
  const { page } = state;

  return (
    <Switch>
      <Route
        path={stepToUrl({ page, step: REGISTRATION_FLOW.createProfile })}
        {...routesConfig}
      >
        <CreateProfile />
      </Route>

      <Route
        path={stepToUrl({ page, step: REGISTRATION_FLOW.suggestedFriends })}
        {...routesConfig}
      >
        <SuggestedFriends />
      </Route>

      <Route
        path={stepToUrl({ page, step: REGISTRATION_FLOW.facebookFriends })}
        {...routesConfig}
      >
        <FacebookFriends />
      </Route>

      <Route
        path={stepToUrl({ page, step: REGISTRATION_FLOW.welcome })}
        {...routesConfig}
      >
        <Welcome />
      </Route>
    </Switch>
  );
};

export default RegistrationFlowRoutes;
